/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import { FormControl } from 'material-ui/Form';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import Card, { CardHeader, CardMedia, CardContent } from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import red from 'material-ui/colors/red';

import { Row } from 'react-flexbox-grid';
import Place from 'material-ui-icons/Place';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import CreateIcon from 'material-ui-icons/Create';

import { CSSTransitionGroup } from 'react-transition-group';
import damMapIcon2 from '../assets/images/icon-map-dam-cotton.png';
import windTurbineMapIcon2 from '../assets/images/icon-map-wind-turbine-cotton.png';
import solarPanelMapIcon2 from '../assets/images/icon-map-solar-panel-cotton.png';
import boltMapIcon2 from '../assets/images/icon-map-bolt-cotton.png';
import placeIcon from '../assets/images/icons/place.png';
import geothermalIcon from '../assets/images/icons/geothermal.png';
import solidBiomassIcon from '../assets/images/icons/solid-biomass.png';

import Menu from 'material-ui/Menu/Menu';
import MenuItem from 'material-ui/Menu/MenuItem';
import { Bar, Chart } from 'react-chartjs-2';
import GoogleMapReact from 'google-map-react';
import Grid from 'material-ui/Grid';
import { withRouter } from 'react-router';
import { translate } from 'react-i18next';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import {
  getAssetProducingStart,
  saveProducingSmartMeterRead,
  setUnit,
  setThirtyDayButtonPressed,
  hideProdAssetDateFilter,
  setCustomButtonPressed,
  displayProdAssetDateFilter,
  toggleProdAssetStartDateDialog,
  toggleProdAssetEndDateDialog,
  setProdAssetStartDate,
  setProdAssetEndDate,
  getAssetProducingRefresh,
} from '../actions';
import {
  checkUserIsAdmin,
  checkUserIsDefinedAndAdminOrSuperAdmin,
} from '../utils/user/checkAdmin/CheckAdmin';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
    height: '100%',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },

  media_img: {
    height: 0,
  },

  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
});

const DEFAULT_PRODUCING_ASSET_MAP_ZOOM_LEVEL = 10;

class AssetProducing extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  static defaultProps = {
    zoom: DEFAULT_PRODUCING_ASSET_MAP_ZOOM_LEVEL,
  };

  state = {
    anchorEl: null,
  };

  getMapOptions = maps => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'poi.business',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,
      maxZoom: 18,

      mapTypeControl: true,
      mapTypeId: maps.MapTypeId.SATELLITE,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [
          maps.MapTypeId.ROADMAP,
          maps.MapTypeId.SATELLITE,
          maps.MapTypeId.HYBRID,
        ],
      },

      zoomControl: true,
      clickableIcons: false,
    };
  };

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  componentWillMount = () => {
    Chart.pluginService.register({
      beforeDraw: function(chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx;

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center;
          var fontStyle =
            centerConfig.fontStyle ||
            '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif';
          var txt = centerConfig.text;
          var color = centerConfig.color || '#000';
          var sidePadding = centerConfig.sidePadding || 20;
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2);
          //Start with a base font of 30px
          ctx.font = '20px ' + fontStyle;

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width;
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(20 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + 'px ' + fontStyle;
          ctx.fillStyle = color;

          //Draw text in center
          ctx.fillText(txt, centerX, centerY);
        }
      },
    });
  };

  componentDidMount = () => {
    if (this.props.isAuthenticated) {
      const {
        match: { params },
      } = this.props;
      this.props.hideProdAssetDateFilter();
      this.props.getAssetProducingStart(params.assetId, this.props.history);
    } else {
      this.props.history.push('/');
    }
  };

  renderAssetType() {
    const assetTypes = [
      {
        value: 1,
        label: this.props.t('Solar'),
      },
      {
        value: 2,
        label: this.props.t('RunRiverHydro'),
      },
      {
        value: 3,
        label: this.props.t('BiomassGas'),
      },
      {
        value: 4,
        label: this.props.t('Wind'),
      },
      {
        value: 5,
        label: this.props.t('Geothermal'),
      },
      {
        value: 6,
        label: this.props.t('SolidBiomass'),
      },
    ];

    if (this.props.currentAssetProducing.assetType) {
      let type = assetTypes.find(assetType => {
        return (
          parseInt(this.props.currentAssetProducing.assetType, 10) ===
          assetType.value
        );
      });
      return type.label;
    }
  }

  renderBarChart() {
    const { classes, unit, t } = this.props;

    if (this.props.graphDataProducer.barChartData.length <= 0) {
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    }

    const LIGHT_ORANGE_ALPHA_LEVEL_2 = 'rgba(248,119,51,0.2)';
    const LIGHT_ORANGE_ALPHA_LEVEL_4 = 'rgba(248,119,51,0.9)';
    const LIGHT_ORANGE_OPAQUE = 'rgba(248,119,51,1)';

    let datasets = [
      {
        label: t('Matched energy'),
        backgroundColor: LIGHT_ORANGE_ALPHA_LEVEL_4,
        borderColor: LIGHT_ORANGE_OPAQUE,
        borderWidth: 1,
        hoverBackgroundColor: LIGHT_ORANGE_ALPHA_LEVEL_4,
        hoverBorderColor: LIGHT_ORANGE_OPAQUE,
        data: this.props.graphDataProducer.barChartData.matchedProductionData,
      },
      {
        label: t('Available energy'),
        backgroundColor: LIGHT_ORANGE_ALPHA_LEVEL_2,
        borderColor: LIGHT_ORANGE_OPAQUE,
        borderWidth: 1,
        hoverBackgroundColor: LIGHT_ORANGE_ALPHA_LEVEL_2,
        hoverBorderColor: LIGHT_ORANGE_OPAQUE,
        data: this.props.graphDataProducer.barChartData.availableProductionData,
      },
    ];

    let dateFormat = 'YYYY-MM-DD'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'DD-MM-YYYY';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM-DD-YYYY'; //American date
    }

    let labels = this.props.graphDataProducer.barChartLabels.map(label => {
      return moment(label).format(dateFormat);
    });

    let data = {
      labels: labels,
      datasets,
    };

    return (
      <Bar
        data={data}
        width={1200}
        height={400}
        options={{
          maintainAspectRatio: false,
          responsive: true,
          tooltips: {
            intersect: false,
            mode: 'index',
            filter: tooltipItem => {
              return parseFloat(tooltipItem.yLabel) > 0;
            },
            callbacks: {
              title: tooltipItem => {
                if (tooltipItem[0]) {
                  let firstData = tooltipItem[0];
                  return firstData.label;
                } else {
                  return null;
                }
              },
              label: (tooltipItem, data) => {
                let dataDisplayed = '';
                switch (unit) {
                  case false:
                    dataDisplayed = '';
                    break;
                  case 'kWh':
                    dataDisplayed =
                      Math.round(tooltipItem.yLabel).toLocaleString() + ' kWh';
                    break;
                  case 'MWh':
                    dataDisplayed =
                      Math.round(tooltipItem.yLabel / 1000).toLocaleString() +
                      ' MWh';
                    break;
                  default:
                    dataDisplayed = '';
                }

                dataDisplayed =
                  data.datasets[tooltipItem.datasetIndex].label +
                  ' : ' +
                  dataDisplayed;

                return dataDisplayed;
              },
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  callback: function(value) {
                    let valueDisplayed = '';
                    switch (unit) {
                      case false:
                        valueDisplayed = '';
                        break;
                      case 'kWh':
                        valueDisplayed = Math.round(value).toLocaleString();
                        break;
                      case 'MWh':
                        valueDisplayed = Math.round(
                          value / 1000
                        ).toLocaleString();
                        break;
                      default:
                        valueDisplayed = '';
                    }
                    return valueDisplayed;
                  },
                },
              },
            ],
          },
        }}
      />
    );
  }

  renderCharte() {
    const { currentAssetProducing } = this.props;

    if (!currentAssetProducing || !currentAssetProducing.charteFilename) {
      return;
    }

    const documentIcon = require('../assets/images/icons/document.png');
    const charteFileUrl =
      'https://www.dropbox.com/s/wfla77l9w1eed0a/charte_rse.pdf?dl=0';

    return (
      <a href={charteFileUrl} target="_blank">
        <img
          src={documentIcon}
          style={{ maxHeight: 40, marginRight: 20 }}
          alt="Charte"
        />
      </a>
    );
  }

  renderCertifications() {
    const { currentAssetProducing } = this.props;

    if (!currentAssetProducing || !currentAssetProducing.certifications) {
      return;
    }

    if (
      currentAssetProducing.certifications &&
      currentAssetProducing.certifications.length === 0
    ) {
      return;
    }

    return currentAssetProducing.certifications.map(certification => {
      const certificationIcon = require('../assets/images/' +
        certification.logoName);
      return (
        <a href={certification.url} target="_blank">
          <img
            src={certificationIcon}
            style={{ maxHeight: 40, marginRight: 20 }}
          />
        </a>
      );
    });
  }

  renderUpdateButton(history) {
    const {
      classes,
      isAuthenticated,
      user,
      currentAssetProducing,
    } = this.props;
    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => {
            this.props.history.push(
              '/assets/prod/update/' + currentAssetProducing.id
            );
          }}
        >
          <CreateIcon />
        </Button>
      );
    } else return false;
  }

  renderThirtyDaysFilterButton() {
    const { classes, currentAssetProducing, loading } = this.props;

    return (
      <Button
        variant={this.props.thirtyDaysButtonPressed ? 'raised' : 'flat'}
        color="primary"
        className={classes.button}
        disabled={loading}
        onClick={async () => {
          this.props.setThirtyDayButtonPressed();
          this.props.hideProdAssetDateFilter();
          this.props.getAssetProducingStart(
            currentAssetProducing.id,
            this.props.history
          );
        }}
        type="submit"
      >
        {loading ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          '30 days'
        )}
      </Button>
    );
  }

  renderCustomButton() {
    const { classes, loading } = this.props;

    return (
      <Button
        color="primary"
        variant={this.props.customButtonPressed ? 'raised' : 'flat'}
        className={classes.button}
        disabled={loading}
        onClick={() => {
          this.props.setCustomButtonPressed();
          this.props.displayProdAssetDateFilter();
        }}
      >
        {loading ? (
          <CircularProgress size={24} className={classes.buttonProgress} />
        ) : (
          'Custom'
        )}
      </Button>
    );
  }

  renderTimeNavigation() {
    return (
      <Grid item xs={12} sm={12} style={{ minWidth: '100%' }}>
        <div style={{ float: 'left' }}>
          <div style={{ marginLeft: 10, marginRight: 10, float: 'left' }}>
            {this.renderThirtyDaysFilterButton()}
          </div>
          <div style={{ marginLeft: 10, float: 'left' }}>
            {this.renderCustomButton()}
          </div>
        </div>
      </Grid>
    );
  }

  renderFormContainer() {
    return (
      <Grid item xs={12} sm={12} style={{ minWidth: '100%' }}>
        <div style={{ float: 'left' }}>
          <CSSTransitionGroup
            transitionName="example"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {this.props.showDateFilter ? this.renderForm() : false}
          </CSSTransitionGroup>
        </div>
      </Grid>
    );
  }

  renderForm() {
    const {
      classes,
      currentAssetProducing,
      loading,
      startDate,
      endDate,
    } = this.props;

    let dateFormat = 'yyyy/MM/dd'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'dd/MM/yyyy';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM/dd/yyyy'; //American date
    }

    return (
      <Row>
        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 18,
            }}
          />
          <div style={{ marginTop: 12 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                format={dateFormat}
                openTo={'year'}
                label="Start date"
                value={startDate}
                onChange={newDate => {
                  if (!moment(newDate).isValid() || !newDate) {
                    newDate = null;
                  }

                  this.props.setProdAssetStartDate(newDate);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                className={classes.inputWithMargin}
              />
            </MuiPickersUtilsProvider>
          </div>
        </FormControl>

        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 18,
            }}
          />
          <div style={{ marginTop: 12, marginLeft: 10 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                format={dateFormat}
                openTo={'year'}
                label="End date"
                value={endDate}
                onChange={newDate => {
                  if (!moment(newDate).isValid() || !newDate) {
                    newDate = null;
                  }

                  this.props.setProdAssetEndDate(newDate);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                className={classes.inputWithMargin}
              />
            </MuiPickersUtilsProvider>
          </div>
        </FormControl>
        <Button
          style={{ marginLeft: 12, marginTop: 20 }}
          variant="raised"
          color="primary"
          className={classes.button}
          disabled={loading}
          onClick={async () => {
            await this.props.getAssetProducingRefresh(
              currentAssetProducing.id,
              this.props.history,
              moment(startDate).format('YYYY-MM-DD'),
              moment(endDate).format('YYYY-MM-DD')
            );
          }}
          type="submit"
        >
          {loading ? (
            <CircularProgress size={24} className={classes.buttonProgress} />
          ) : (
            'Ok'
          )}
        </Button>
      </Row>
    );
  }

  render() {
    const { anchorEl } = this.state;
    const { classes, currentAssetProducing, loading, t, user } = this.props;

    if (loading) {
      return (
        <div className={classes.root}>
          <CircularProgress size={24} className={classes.buttonProgress} />
        </div>
      );
    }

    let assetIcon = boltMapIcon2;

    switch (currentAssetProducing.assetType) {
      case 1:
        assetIcon = solarPanelMapIcon2;
        break;
      case 2:
        assetIcon = damMapIcon2;
        break;
      case 4:
        assetIcon = windTurbineMapIcon2;
        break;
      case 5:
        assetIcon = geothermalIcon;
        break;
      case 6:
        assetIcon = solidBiomassIcon;
        break;
      default:
        assetIcon = boltMapIcon2;
    }

    const assetLat =
      currentAssetProducing && currentAssetProducing.gpsLatitude
        ? parseFloat(
            currentAssetProducing.gpsLatitude.toString().replace(',', '.')
          )
        : '48.880343';
    const assetLng =
      currentAssetProducing && currentAssetProducing.gpsLongitude
        ? parseFloat(
            currentAssetProducing.gpsLongitude.toString().replace(',', '.')
          )
        : '2.325582';
    const center = {
      lat: assetLat,
      lng: assetLng,
    };

    let numberAndStreet = '';
    if (currentAssetProducing.houseNumber && currentAssetProducing.street) {
      numberAndStreet =
        currentAssetProducing.houseNumber +
        ' ' +
        currentAssetProducing.street +
        ', ';
    } else if (
      !currentAssetProducing.houseNumber &&
      currentAssetProducing.street
    ) {
      numberAndStreet = currentAssetProducing.street + ', ';
    } else if (
      currentAssetProducing.houseNumber &&
      !currentAssetProducing.street
    ) {
      numberAndStreet = currentAssetProducing.houseNumber + ', ';
    }

    let zipCode = currentAssetProducing.zip
      ? currentAssetProducing.zip + ', '
      : '';
    let city = currentAssetProducing.city
      ? currentAssetProducing.city + ', '
      : '';
    let region = currentAssetProducing.region
      ? currentAssetProducing.region + ', '
      : '';
    let country = currentAssetProducing.country
      ? currentAssetProducing.country
      : '';

    let fullAddress = numberAndStreet + zipCode + city + region + country;

    const forecastUrl =
      'https://forecast.io/embed/#lat=' +
      assetLat +
      '&lon=' +
      assetLng +
      '&name=' +
      currentAssetProducing.city +
      '&color=#F87733&font=Avenir&units=ca';
    return (
      <div className={classes.root}>
        {this.renderUpdateButton()}
        <Grid container spacing={24}>
          {this.renderTimeNavigation()}
          {this.renderFormContainer()}
          {(currentAssetProducing.displayGraphData ||
            checkUserIsDefinedAndAdminOrSuperAdmin(user)) && (
            <Grid item xs={12} sm={12}>
              <Card className={classes.card}>
                <CardHeader
                  action={
                    <div>
                      <IconButton
                        aria-owns={anchorEl ? 'simple-menu' : null}
                        aria-haspopup="true"
                        onClick={this.handleMenuClick}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleMenuClose}
                      >
                        <MenuItem
                          onClick={() => {
                            this.handleMenuClose();
                            this.props.setUnit(false);
                          }}
                        >
                          {t('No figures')}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            this.handleMenuClose();
                            this.props.setUnit('kWh');
                          }}
                        >
                          kWh
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            this.handleMenuClose();
                            this.props.setUnit('MWh');
                          }}
                        >
                          MWh
                        </MenuItem>
                      </Menu>
                    </div>
                  }
                  avatar={<img src={assetIcon} style={{ maxHeight: 20 }} />}
                  title={t('Asset production')}
                  subheader={'Subheader'}
                  subheader={
                    this.props.unit
                      ? t('Energy from ') +
                        t(this.renderAssetType()) +
                        t(' (in ') +
                        this.props.unit +
                        ')'
                      : t('Energy from ') + this.renderAssetType()
                  }
                />
                <div
                  style={{
                    height: 300,
                  }}
                >
                  {this.renderBarChart()}
                </div>
              </Card>
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <Card className={classes.card} style={{ minHeight: 469 }}>
              <CardHeader
                avatar={<img src={placeIcon} style={{ maxHeight: 20 }} />}
                title={currentAssetProducing.displayedName}
                subheader={fullAddress}
              />
              <div style={{ height: 365, width: '100%' }}>
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: 'AIzaSyBleDoIxwGmKTDHbxeaMFo-ny5e-xEPoNs',
                  }}
                  center={center}
                  defaultZoom={this.props.zoom}
                  zoom={this.props.zoom}
                  options={this.getMapOptions}
                >
                  <div lat={assetLat} lng={assetLng}>
                    <Place style={{ color: '#F87733' }} />
                  </div>
                </GoogleMapReact>
              </div>
            </Card>
          </Grid>

          <Grid
            container
            direction="column"
            alignItems="center"
            item
            xs={12}
            sm={6}
          >
            <Card style={{ minHeight: 469 }}>
              <CardMedia className={classes.media_img} title="">
                <img
                  style={{ height: 469 }}
                  crossOrigin="use-credentials"
                  src={
                    currentAssetProducing.id || currentAssetProducing.id === 0
                      ? process.env.REACT_APP_API_URL +
                        '/static/prod_asset_' +
                        currentAssetProducing.id +
                        '.jpg'
                      : ''
                  }
                />
              </CardMedia>
              <CardContent>
                <Typography className={classes.title} color="textSecondary">
                  <p>
                    <span style={{ fontWeight: 'bold' }}>{t('Capacity')} </span>{' '}
                    {parseInt(currentAssetProducing.capacityWh / 1000000, 10)}{' '}
                    MW
                  </p>
                  <p>
                    {this.renderCertifications()}
                    {this.renderCharte()}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {false && (
            <Grid item xs={12}>
              <Card className={classes.card}>
                <CardHeader
                  action={
                    <IconButton>
                      <MoreVertIcon />
                    </IconButton>
                  }
                  title={t('Weather')}
                  subheader={t('Forecast')}
                />
                {currentAssetProducing.gpsLatitude &&
                currentAssetProducing.city ? (
                  <iframe
                    id="forecast_embed"
                    frameBorder="0"
                    width="100%"
                    height="245"
                    src={forecastUrl}
                  />
                ) : (
                  ''
                )}
              </Card>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

AssetProducing.contextTypes = {
  router: PropTypes.object,
};
AssetProducing.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  assetsProducingReducer,
  router,
  loginReducer,
  utilsReducer,
}) => {
  const {
    currentAssetProducing,
    loading,
    loadingMeterRead,
    graphDataProducer,
    thirtyDaysButtonPressed,
    customButtonPressed,
    dialogStartDateOpen,
    dialogEndDateOpen,
    startDate,
    endDate,
    showDateFilter,
  } = assetsProducingReducer;
  const { unit } = utilsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    currentAssetProducing,
    loading,
    location,
    loadingMeterRead,
    graphDataProducer,
    isAuthenticated,
    username,
    user,
    unit,
    thirtyDaysButtonPressed,
    showDateFilter,
    customButtonPressed,
    dialogStartDateOpen,
    dialogEndDateOpen,
    startDate,
    endDate,
  };
};

const mapDispatchToProps = {
  getAssetProducingStart,
  saveProducingSmartMeterRead,
  setUnit,
  setThirtyDayButtonPressed,
  hideProdAssetDateFilter,
  setCustomButtonPressed,
  displayProdAssetDateFilter,
  toggleProdAssetStartDateDialog,
  toggleProdAssetEndDateDialog,
  setProdAssetStartDate,
  setProdAssetEndDate,
  getAssetProducingRefresh,
};

AssetProducing = withStyles(styles, { name: 'AssetProducing' })(AssetProducing);
AssetProducing = translate('translations')(AssetProducing);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssetProducing)
);



// WEBPACK FOOTER //
// ./src/components/AssetProducing.js